import { ITransaction } from '@wot/typings';
import { parseISO } from 'date-fns';
import { format } from 'date-fns/esm';
import { useState } from 'react';
import Chip from '../../../components/Chip';
import { TableRowItemData } from '../../../components/Table';

export default function TableRowItem({ transaction }: { transaction: ITransaction }) {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <>
      <TableRowItemData text={format(parseISO(transaction.createdAt), 'dd/MM/yyyy')} />
      <TableRowItemData text={transaction._id} />
      <TableRowItemData text={transaction.user.name} />
      <TableRowItemData text={transaction.user.email} />
      {/* <TableRowItemData text={"Description"} /> */}
      <TableRowItemData text={`INR ${transaction.amount}`} />
      <TableRowItemData text={transaction.modeOfPayment} />
      <TableRowItemData
        component={
          <div className="w-full flex items-center justify-between">
            <Chip
              state={
                transaction.status === 'created'
                  ? 'pending'
                  : transaction.status === 'processing'
                    ? 'pending'
                    : transaction.status === 'succeeded'
                      ? 'success'
                      : transaction.status === 'failed'
                        ? 'error'
                        : 'pending'
              }
            >
              <p className="text-sm font-semibold capitalize">{transaction.status === "created" ? "Attempted" : transaction.status}</p>
            </Chip>
          </div>
        }
      />
    </>
  );
}
